// import { useState, useEffect } from 'react';
import StudentSidebar from '../components/StudentSidebar.js';
import StudentCalendar from '../components/StudentCalendar.js';

export default function StudentCalendarPage() {

    return (
        <div className="student-dashboard-panel">
            {/* Sidebar */}
            <StudentSidebar />
            {/* Main Content */}
            <div className='main-content'>
                {/* Header */}
                <div className='header'>
                    <h1 className='header-title'>Kalendarz zajęć</h1>
                </div>
                {/* Dashboard Content */}
                <div className="dashboard">
                     <div className='student-header'>
                        <h1 className='student-title'>Kalendarz zajęć</h1>
                        <p className="student-subheading">Kalendarz zajęć i wydarzeń</p>
                     </div>
                     <div className='menagment-content'>
                        <StudentCalendar />
                     </div>
                </div>
            </div>
        </div>
    );
}